import React from 'react';
import Modal from 'components/new_ui/Modal/Modal';

import { Row, Col } from 'react-bootstrap5';

import { useNavigate } from 'react-router-dom';

import { useContext } from 'components/Members/Programs/Views/Show/Context';

import { Formik, Form as FormikForm } from 'formik';
import * as Yup from 'yup';

import Footer from 'components/Widgets/Profile/FormFooter';
import HorizontalTextField from 'components/new_ui/Form/HorizontalTextField';

import Alert from 'components/new_ui/Alerts/alert';

export default function Index() {
  const navigate = useNavigate();

  const { dispatch, actions, state } = useContext();

  const formSchema = Yup.object().shape({
    reason: Yup.string().typeError('Reason is required'),
  });

  const onSubmitHundler = (values, { setSubmitting }) => {
    setSubmitting(true);
    actions.sendChangeCoachRequest(dispatch, values, state.program.id, () => {
      setSubmitting(false);
      navigate(-1);
      Alert({
        title: 'Coach Change Request',
        html: `<p>
          Your coach change request was successfully submitted.</p>
          <p>We will notify you as soon as your request was approved and you
          can select your new coach.</p> <p>Please contact your Success Manager via the
          support chat widget if you have any additional questions.
        </p>`,
      });
    }, (errorMessage) => {
      setSubmitting(false);
      Alert({
        title: 'Coach Change Request',
        text: errorMessage,
      });
    });
  };

  return (
    <Modal
      show
      header={<h3>Coach Change Request</h3>}
      onHide={() => navigate(-1)}
    >

      <Formik
        validationSchema={formSchema}
        initialValues={{
          coachName: state.program.attributes.coach?.full_name,
          programName: state.program.attributes.title,
          reason: null,
        }}
        onSubmit={onSubmitHundler}
      >
        {({ isSubmitting }) => (
          <FormikForm className="needs-validation" noValidate="">
            <Row>
              <Col>
                <HorizontalTextField
                  name="coachName"
                  label="Coach"
                  disabled
                  required
                />
              </Col>
            </Row>

            <Row>
              <Col>
                <HorizontalTextField
                  name="programName"
                  label="Program"
                  disabled
                  required
                />
              </Col>
            </Row>

            <Row>
              <Col>
                <HorizontalTextField
                  name="reason"
                  label="Reason"
                  as="textarea"
                  required
                  rows="6"
                />
              </Col>
            </Row>

            <Footer loading={isSubmitting} buttonName="Send" onCancel={() => navigate(-1)} />
          </FormikForm>
        )}
      </Formik>

    </Modal>
  );
}
